module.exports = __webpack_public_path__ + "img/server.9fa903d9.png";